import React from 'react';

const OPTIONS = [
  ['all', 'All'],
  ['real', 'Real'],
  ['demo', 'Demo'],
];

export default function AccountTypeFilter({ value, onChange, className = '' }) {
  return (
    <div
      className={`inline-flex items-center rounded-lg border border-dark-border bg-dark-bg p-1 ${className}`}
      role="group"
      aria-label="Account type"
    >
      {OPTIONS.map(([key, label]) => (
        <button
          key={key}
          type="button"
          onClick={() => onChange(key)}
          aria-pressed={value === key}
          className={`min-w-[58px] rounded-md px-3 py-1.5 text-xs font-semibold transition-colors ${
            value === key
              ? 'bg-blue-500 text-white'
              : 'text-gray-400 hover:bg-dark-hover hover:text-gray-100'
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}